<template>
  <span class="ya-te-badge-required co-display-14 badge rounded border-0 bg-co-warning-500 p-2 text-co-gray-50">
    <slot>必須</slot>
  </span>
</template>

<style scoped>
.ya-te-badge-required {
  color: #fff;
  background-color: #f03;
}
</style>
